<div class="course-details-breadcrumb-1 bg_image rts-section-gap">
  <div class="container">
    <div class="row">
      <div class="col-lg-12">
        <div class="single-course-left-align-wrapper">
          <div class="meta-area">
            <a class="text-white" [routerLink]="['/']">Início</a>
            <i class="fa-solid fa-chevron-right text-white"></i>
            <a class="active text-white" [routerLink]="['/polos']"
              >Polos de Apoio Presencial</a
            >
          </div>
          <h1 class="title text-white">Conheça os Polos de Apoio Presencial</h1>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="about-area-start style-two mb--200">
  <div class="container">
    <p class="paragraph">
      A Facint está em pleno processo de expansão nacional por meio da oferta de
      cursos na modalidade Educação a Distância (EaD). Com o compromisso de
      levar uma formação de excelência a todas as regiões do país, buscamos
      parceiros que compartilhem do nosso propósito educacional e queiram fazer
      parte desse projeto transformador.
    </p>

    <p class="paragraph">
      Estamos credenciando novos polos de apoio presencial, que serão
      responsáveis por oferecer suporte acadêmico local, orientação aos
      estudantes, atividades práticas e avaliações presenciais, seguindo o
      padrão de qualidade que caracteriza o DNA Facint — inovação,
      acessibilidade e compromisso com a formação integral.
    </p>

    <p class="paragraph">
      Se você deseja representar uma instituição moderna, com foco na
      empregabilidade e no desenvolvimento humano, torne-se um Polo da Facint e
      contribua para ampliar as fronteiras do conhecimento em sua região.
    </p>

    <p class="paragraph">
      Em breve, divulgaremos a lista oficial dos polos autorizados.
    </p>
  </div>
</div>
